
import request from '@/util/http'
import qs from "qs";
// 获取学科分页
export function getSubject (query) {
    return request({
        url: '/admin/majors/page',
        method: 'get',
        params: query
    })
}

//新增学科分页
export function addSubject (query) {
    return request({
        url: '/admin/majors',
        method: 'post',
        data: query
    })
}

//修改学科
export function putSubject (obj) {
    return request({
        url: '/admin/majors',
        method: 'put',
        data: obj
    })
}

//删除专业
export function deleteSubject (obj) {
    return request({
        url: '/admin/majors',
        method: 'delete',
        data: obj
    })
}
// 获取专业等级
export function majorType (type) {
    return request({
        url: '/admin/dict/type/' + type,
        method: 'get',
    })
}


// 专业-管理-
// 教师list
export function teacherList (obj) {
    return request({
        url: '/admin/teacher/page',
        method: 'get',
        params: obj
    })
}
// 删除教师
export function DelTeacher (id) {
    return request({
        url: '/admin/teacher/' + id,
        method: 'DELETE',
    })
}

export function DelBatchTeacher (query) {
    let param = {
            ids : ''
    };
    let ids = ''
    // query.forEach(item => {
    //     param.ids += `${item},`;
    //     ids += `${item},`;
    // });
    return request({
        url: '/admin/teacher/delBatch/',
        method: 'DELETE',
        // headers: { "content-type": "application/x-www-form-urlencoded" },
        data: query
    })
}
export function updateTeacher (obj,v) {
    return request({
        url: '/admin/teacher',
        method: v,
        data: obj
    })
}